var Utility;
(function (Utility) {
    var ns = 'validate';
    var Controller = (function () {
        function Controller() {

        }

        Controller.prototype.submit = function (form) {
            let _form = document.forms[form];
            if (_form) {
                _form.submit();
            }
            return this;
        };
        Controller.submit = Controller.prototype.submit;

        Controller.prototype.validateForm = function (form, id, onclick) {
            form = $('form[name="' + form + '"]');
            var button = $('#' + id).on('click', function () {
                var self = $(this);
                if (!self.is('[disabled]')) {
                    this.setAttribute('disabled', 'disabled');
                    self.find('.button-icon')
                        .removeClass('icon-status_ok')
                        .addClass('icon-time_hour_glass');

                    eval(onclick);
                }
            });
            var validate = function () {
                var disable = false;

                form.find('[data-valid]').each(function () {
                    if (!$(this).data('valid')) {
                        disable = true;
                        gb.logging.log('!$(this).data(\'valid\')', ns);
                        gb.logging.log(this, ns);
                        console.dir(this);
                        return;
                    }
                });

                if (!disable) {
                    form.find('[data-val-required]').each(function () {
                        if (this.value.length === 0) {
                            disable = true;
                            gb.logging.log('this.value.length === 0', ns);
                            gb.logging.log(this, ns);
                            console.dir(this);
                            return;
                        }
                    });
                }

                if (!disable) {
                    var chkReq = form.find('input:checkbox[required]');
                    if (chkReq.length > 0 && !chkReq.is(':checked')) {
                        gb.logging.log('chkReq.length > 0 && !chkReq.is(\':checked\')', ns);
                        gb.logging.log(this, ns);
                        console.dir(this);
                        disable = true;
                    }
                }

                if (!disable) {
                    var groups = {};
                    form.find('*[data-validation-group]').each(function () {
                        var name = $(this).data('validation-group');
                        if (!groups[name]) {
                            groups[name] = [];
                        }
                        var group = groups[name];
                        group[group.length] = this;
                    });

                    for (var key in groups) {
                        var group = groups[key];
                        var validGroup = false;

                        for (var index in group) {
                            if (validGroup) {
                                break;
                            } else {
                                var input = group[index];
                                if (input.type === 'checkbox') {
                                    validGroup = input.checked;
                                } else {
                                    validGroup = input.value.length > 0;
                                }
                            }
                        }

                        if (!validGroup) {
                            disable = true;
                            gb.logging.log('$(this).data(\'validation-group\')', ns);
                            gb.logging.log(this, ns);
                            console.dir(this);
                            break;
                        }
                    }
                }
                button.attr('disabled', disable);
            };
            validate();

            form.on('change', '[data-valid]', validate)
                .on('change input', '[data-val-required]', validate)
                .on('change', 'input:checkbox[required]', validate)
                .on('change input', '[data-validation-group]', validate)
                .on('validate', validate);
        };
        Controller.validateForm = Controller.prototype.validateForm;

        Controller.prototype.clearNames = function (form, toReplace) {
            $('form[name="' + form + '"]').find('*[name]').each(function (k, v) {
                v.setAttribute('name', v.name.replace(toReplace, ''));
            });
            return this;
        };
        Controller.clearNames = Controller.prototype.clearNames;

        return Controller;
    })();
    Utility.Controller = Controller;
})(Utility || (Utility = {}));

var utility = new Utility.Controller();